import { Alert, Typography } from '@mui/material';
import { FC, useEffect, useMemo } from 'react';
import { Loader, useListDataRequest } from '../../../ui';
import { getScanList } from '../../network';
import { EmptyContainer, LoadingContainer } from './styles';
import { MeshViewerV2 } from '../../new/NewMeshViewer';
import { useCompareStore } from '../../new/CompareControls/useCompareStore';

export interface ScanCompareProps {
  patientId: string | number;
  selectedScanId?: string | number | null;
}

export const ScanCompare: FC<ScanCompareProps> = (props) => {
  const { patientId, selectedScanId } = props;

  const listParams = useMemo(
    () => ({
      filters: {
        patient: patientId,
      },
      pagination: {
        size: 1000,
        page: 1,
      },
    }),
    [patientId]
  );
  const { data, loading, error } = useListDataRequest(getScanList, listParams);

  const { setLeftScan, isLoading: isScanLoading } = useCompareStore();

  useEffect(() => {
    if (selectedScanId) {
      setLeftScan(selectedScanId);
    }
  }, [selectedScanId, setLeftScan]);

  if (loading) {
    return (
      <LoadingContainer>
        <Loader />
      </LoadingContainer>
    );
  }

  if (error) {
    return <Alert color='error'>{error.message}</Alert>;
  }

  if (!data || data.length === 0) {
    return (
      <EmptyContainer>
        <Typography variant='h4'>Patient don’t have scans yet...</Typography>
      </EmptyContainer>
    );
  }

  return (
    <div style={{ position: 'relative' }}>
      <MeshViewerV2 scans={data} />
      {isScanLoading && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Loader />
        </div>
      )}
    </div>
  );
};
